import { useState, useEffect, useCallback } from 'react'
import { getItems, updateItemReview } from '../api/library'

export function useLibraryItems() {
  const [items, setItems] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  useEffect(() => {
    let cancelled = false
    setLoading(true)
    setError(null)

    getItems()
      .then((data) => {
        if (!cancelled) setItems(data)
      })
      .catch((err) => {
        if (!cancelled) setError(err.message)
      })
      .finally(() => {
        if (!cancelled) setLoading(false)
      })

    return () => {
      cancelled = true
    }
  }, [])

  const updateReview = useCallback(async (itemId, { rating, review }) => {
    const updated = await updateItemReview(itemId, { rating, review })
    setItems((prev) => prev.map((item) => (item.id === itemId ? updated : item)))
    return updated
  }, [])

  return { items, loading, error, updateReview }
}
